import { hrApiClient } from '@/lib/api';
import { IOAuthClientInfo } from '@/features/auth/types/oauth.types';

export async function getOAuthClientInfo(clientId: string) {
  const { data } = await hrApiClient.get<IOAuthClientInfo>(
    `/oauth/client/${clientId}`,
  );
  return data;
}
